import { Component } from "@angular/core";
import { MeetingAgendaItemComponent } from "@org-common/lib/meetings/meeting-agenda-component-registry";
import { TourIdentifier } from "../../../tours/tour-identifier.enum";

@MeetingAgendaItemComponent("adapt-quarterly-objectives-key-results-agenda-item")
@Component({
    selector: "adapt-quarterly-objectives-key-results-agenda-item",
    templateUrl: "./quarterly-objectives-key-results-agenda-item.component.html",
    standalone: false,
})
export class QuarterlyObjectivesKeyResultsAgendaItemComponent {
    public readonly PageActivationTours = [TourIdentifier.CreateKeyResultsForObjectiveFeatureTour];
}
